module.exports = __webpack_public_path__ + "img/night.3a9d432b.png";